import styled from 'styled-components'
import { Select } from 'components/generic/Input/SelectInput/styles'
import { Input } from 'components/generic/Input/TextInput'
import InputErrorMessage from 'components/generic/Input/InputErrorMessage'
import { FONT_FAMILY } from 'utils/Constants'

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;

  ${Input} {
    width: 90px;
  }

  ${Select} {
    margin-left: 1rem;
  }
`

export const ErrorMessage = styled(InputErrorMessage)`
  margin-left: auto;
  margin-right: auto;
`

export const DollarSign = styled.span`
  align-self: center;
  color: ${({ theme }) => theme.colors.textColor};
  display: block;
  margin-right: 0.5rem;
  margin-bottom: ${({ isSelectWageTypeEnabled }) => (isSelectWageTypeEnabled ? '0' : '1.5rem')};
`

export const SkipText = styled.p`
  align-self: center;
  color: ${({ theme }) => theme.colors.textColor};
  font-family: ${FONT_FAMILY.PROXIMA_NOVA};
  font-size: 14px;
  margin-bottom: -1.25rem;
`
